import { render } from "./mappings_preview.vue?vue&type=template&id=5d262b2a&scoped=true"
import script from "./mappings_preview.vue?vue&type=script&lang=js"
export * from "./mappings_preview.vue?vue&type=script&lang=js"

import "./mappings_preview.vue?vue&type=style&index=0&id=5d262b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d262b2a"]])

export default __exports__